import lookup from "country-code-lookup";

export const getCountryCode = (
  marketName: string,
  countryCode: string,
  identity: string
) => {
  let marketCode = lookup.countries.filter(
    (obj: {internet: string, country: string}) =>
      obj?.country === marketName ||
      obj?.internet === countryCode ||
      obj?.internet === identity
  );
  let resultCode = "";
  if (countryCode === "HSS" || countryCode?.startsWith("HSS")) {
    resultCode = "us";
  } else if (
    countryCode === "Spirit Drinkers" ||
    countryCode?.startsWith("CTM-CA")
  ) {
    resultCode = "spiritDrinkers";
  } else {
    resultCode = marketCode[0]?.internet?.toLowerCase();
  }
  return resultCode;
};
